import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-services',
    template: '<router-outlet></router-outlet>',
})
export class ServicesComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
